import React, { useState } from "react";
import "./selectPlan.css";
import dollar from "../../asset/dollar.svg";
import dollarsilver from "../../asset/dollarsilver.svg";
import dollarbasic from "../../asset/dollarbasic.svg";
import { useNavigate } from "react-router-dom";

const SelectPlan = () => {
  const [formData, setFormData] = useState({ amount: "", plan: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    navigate("/MakePayment", { state: formData });
  };
  return (
    <>
      <div className="selectPlanPage">
        <h3>Make a deposit</h3>
        <h6>Select a plan</h6>
        <form onSubmit={handleSubmit} className="selectForm">
          <div className="sppList">
            <div className="sppOne">
              <h3>
                Basic <img src={dollarbasic} alt="" />
              </h3>
              <p className="percent">10%</p>
              <p>Minimum - $100</p>
              <p>Maximum - Unlimited</p>
              <p>Plan Duration: 24hours</p>
              <p>Capital Included</p>
            </div>

            <div className="sppTwo">
              <h3>
                Silver <img src={dollarsilver} alt="" />
              </h3>
              <p className="percent">15%</p>
              <p>Minimum - $1,000</p>
              <p>Maximum - Unlimited</p>
              <p>Plan Duration: 48hours</p>
              <p>Capital Included</p>
            </div>

            <div className="sppThree">
              <h3>
                Gold <img src={dollar} alt="" />
              </h3>
              <p className="percent">20%</p>
              <p>Minimum - $5,000</p>
              <p>Maximum - Unlimited</p>
              <p>Plan Duration: 3 days</p>
              <p>Capital Included</p>
            </div>
            <div className="sppFour">
              <h3>
                Platinum <img src={dollar} alt="" />
              </h3>
              <p className="percent">30%</p>
              <p>Minimum - $10,000</p>
              <p>Maximum - Unlimited</p>
              <p>Plan Duration: 1 week</p>
              <p>Capital Included</p>
            </div>
          </div>
          <label htmlFor="amount">
            Enter Amount
            <input
              type="number"
              name="amount"
              placeholder="100.00"
              value={formData.amount}
              onChange={handleChange}
            />
          </label>

          <label htmlFor="bitcoin">
            <input type="radio" name="bitcoin" id="bitcoin" />
            Deposit from Bitcoin
          </label>
          <label htmlFor="deposit-from-usdt">
            <input
              type="radio"
              name="deposit-from-usdt"
              id="deposit-from-usdt"
            />
            Deposit from USDT
          </label>
          <button className="button">Make a Deposit</button>
        </form>
      </div>
    </>
  );
};

export default SelectPlan;
